export default __webpack_public_path__ + "static/media/arrow-right.25db18f4.svg";